import { Card, CardContent, Typography } from "@mui/material";
import theme from "../../../theme";
import { convertPhoneNumber } from "../../../utils/methods/convertPhoneNumber";

const SaleInformation = ({
  data,
  car
}) => {

  console.log(data, car, `SaleInformation`)

  return (
    <Card style={{ borderRadius: "1rem", backgroundColor: "#F8F8F8" }}>
      <CardContent>
        <Typography
          variant="h6"
          fontWeight={600}
          color={theme.palette.primary.main}
          marginBottom="1rem"
        >
          Sale Information
        </Typography>
        <Typography fontWeight={700} color={theme.palette.text.primary}>
          Sales Rep:
        </Typography>
        <Typography marginBottom="1rem" color={theme.palette.text.primary}>
          {data?.Agent_Fname} {data?.Agent_Lname}
        </Typography>

        <Typography fontWeight={700} color={theme.palette.text.primary}>
          Agent Contact Number:
        </Typography>
        <Typography marginBottom="1rem" color={theme.palette.text.primary}>
          {data?.Agent_Phone ? `${convertPhoneNumber(data.Agent_Phone)}` : "N/A"}
        </Typography>

        <Typography fontWeight={700} color={theme.palette.text.primary}>
          Sale Address:
        </Typography>
        <Typography marginBottom="1rem" color={theme.palette.text.primary}>
          {/* Brantford, ON */}
          {data?.address ? data?.address : "N/A"}
        </Typography>

        <Typography fontWeight={700} color={theme.palette.text.primary}>
          Sale Date:
        </Typography>
        <Typography color={theme.palette.text.primary}>
          {/* 2025-01-01 19:20:03 */}
          {data?.date ? data?.date : "N/A"}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default SaleInformation;
